//----- ALL AJAX Calls / Logic -----
//General AJAX request templates used around the site, ideally all AJAX logic should be contained here, using $.ajax instead of the shorthand $.post / $.get to allow for greater configurability.

const callbackContainer = "callbackContainer";
const callbackListContainer = "callbackListContainer";



//Error handling. 
function errorHandler(error) {
  //Output complete error message into the console.
  AXISDebug.output(2, error);
  //Output alert message for the user to report back to us.
  alert("AJAX Request Failed: " + error.status + " " + error.statusText + " Please report this message to your service provider.");

  // TODO: Extend the error handler to format the message better: https://stackoverflow.com/questions/377644/jquery-ajax-error-handling-show-custom-exception-messages

};


// TODO: This is outdated now a new solution for this has been implemeneted using the instance obj.
//TODO:Add in logic to check if user is already in the middle of AJAXing.
var postCount = 0;

var clickCounter = 0;

$('body').on('click', '.AJAXBlock.container', function () {
  //Checks if page is posting if so keep menu active.
  if (postCount > 0) {
    //Increment the click counter.
    clickCounter++;
    //If continuesly clicked then display alert to user.
    if (clickCounter > 5) {
      callouts.create("The content on this page is being updated, please wait for your request to be completed.", 2);
      //Reset click counter.
      clickCounter = 0;
    }
  }
});
//--- AJAX spinner ---
//When an AJAX send & received a "pending" status will be displayed.
var contentBlockSpinner = "<div class=\"AJAXBlock container\"><span class=\"spinner\"></span></div>";

function contentBlockSpinnerMarkup(id) {
  return `<div class="AJAXBlock container" ${expressSelectors()['ajax']['content-block-element']}="${id}">
    <span class="spinner"></span>
  </div>
  `;
}


//Call back spinner container type. Basically whether to cover an entire list or just one item.
var defaultCallBackContainer = 'callbackContainer:first';
var defaultCallBackListContainer = 'callbackListContainer'

function getContentBlockSpinner(id) {
  return contentBlockSpinnerMarkup(id);
}

function ajaxUiToggleBlocker(id) {
  // Get context.
  let context = instances[id]['configuration']['context'];
  // Is list ? 
  let isList = instances[id]['configuration']['is-list'];
  // Check whether there is explity a container set up to handle blocking the ui, i.e. seperating the callback response container with the ui blocking containing, this will be required in a series of situations where you may have a bunch of callback's nested in an area and want to block all other action whilst the server is building  the response.
  const uiBlockerContainer = context.parents('[' + expressSelectors()['ajax']['content-block-container'] + ']');
  // Get container.
  let container = uiBlockerContainer;
  if (!container.length) {
    container = context.parents('.' + (isList ? defaultCallBackListContainer : defaultCallBackContainer));
  }
  // Fallback.
  if (!container.length) {
    if (context.attr(expressSelectors()['modals']['modal-context']) != undefined) {
      // If modal in context then find injection container.
      container = context.find('[' + expressSelectors()['modals']['inject-container'] + ']');
    } else {
      // If inside of a modal then traverse up the DOM.
      container = context.closest('[' + expressSelectors()['modals']['inject-container'] + ']');
    }
  }
  // Fallback to looking for .callbackContainer.
  if (!container.length) {
    container = (instances[id]['configuration'].hasOwnProperty('container') ? instances[id]['configuration']['container'] : undefined);
  }

  if (!container.length) {
    console.error("Couldn't find container");
    return false;
  }
  instances[id]['configuration']['ui-blocker-container'] = container;
  // Are we enabling the blocker or not? 
  let status = (container.find('.AJAXBlock').length ? false : true);
 // let status = ($('body').find('.AJAXBlock').length ? false : true);
  // Call original function.
  let delay = instances[id]['configuration']['content-block-delay'];
  // Fallback.
  if (!delay) {
    delay = 0;
  }
  const blockOptions = {
    id: id,
    status: status,
    isList: isList
  };
  if (!status) {
    if (delay ? setTimeout(() => {AJAXBlock(blockOptions)}, delay) : AJAXBlock(blockOptions));
  } else {
    AJAXBlock(blockOptions);
  }

  
  // Return the status of the blocker.
  // TODO: this should really return the toggleBlocker but that doesnt return anything as it assumes that all DOM manipulation just worked not ideal but this function is in need for a refactor.
  return status;
}

//Spinner.
// TODO: this could do with a refactor to support multiple containers updating at once as this function was written in the context of a blocking buttons not entire areas in the DOM.
function AJAXBlock({id, status, isList}) {
  // Get Context.
  let context = instances[id]['configuration']['context'];
  // Find out whether we're dealing with a form.
  // TODO: when this function does eventually get refactored the fact that we now can detect if the context is a form removed the need for the isList parameter.
  let isForm = context.is('form');
  // Later on holds the callback container context.
  let callbackContainerContext = "";
  // Check whether there is explity a container set up to handle blocking the ui.
  const uiBlockerContainer = (instances[id]['configuration'].hasOwnProperty('ui-blocker-container') ? instances[id]['configuration']['ui-blocker-container'] : null);
  // Detect modal if response container is within a modal.
  const modalContext = instances[id]['configuration']['modal-context'];
  //If this is a single item (i.e product cell) else block the entire list.
  if (isList != true) {
    if (status === false) {
      
      //Remove block.
      //Static build AJAX spinner delay. (for testing)
      // var delay = Math.floor(Math.random() * 3500) + 100;
      // setTimeout(function () {
      //   context.parents("." + defaultCallBackContainer).find(".AJAXBlock").remove();
      //   postCounter();
      // }, delay);
      
      let container = uiBlockerContainer;
      if (!container.length) {
        container = context.parents("." + defaultCallBackContainer);
      }

      // Fallback #1 for example if context has already been removed ( i.e if we set a delay )
      if (!container.length) {
        container = context.closest('[' + expressSelectors()['modals']['inject-container'] + ']');
      }

      // Fallback #2
      if (!container.length) {
        // Attempting to find the container from memory.
        if (instances[id]['configuration']['container'].length) {
          container = instances[id]['configuration']['container'];
        } else {
          AXISDebug.output(3,"Ajax: Failed to recover container context from DOM and Memory.");
        }
      }
      container.find(".AJAXBlock").remove();
      // If in modal then remove lock.
      if (modalContext.length) {
        const modal = AXISModals.toggleModalLock(modalContext, false);
      }
      postCounter();
    } else if (status === true) {
      // If a ui block container has been explicity specified ( i.e. DOM tree with a collection of callbacks ).
      if (uiBlockerContainer.length) {
        callbackContainerContext = uiBlockerContainer;
      } else {
        if (isForm) {
          // Update callback container context to directly above the form.
          callbackContainerContext = context.parent('.' + defaultCallBackContainer);
        } else {
          // Update callback container context.
          callbackContainerContext = context.parents("." + defaultCallBackContainer);
        }
        // Fallback for modals as the callbackContainer might be wrapped around the.modal-container if it was ajax'd in which is too far up the tree ( In situations where we're ajax'in a form inside of a modal ).
        if (!callbackContainerContext.length) {
          callbackContainerContext = context.closest('[inject-container]');
        }
        // Fallback for modals if modal are being passed in as context, then travel down the down instead of up to find the inject-container, this might be the first time the modal is ajax'ing back to the server so there is no content inside of it yet.
        if (!callbackContainerContext.length) {
          callbackContainerContext = context.find('[inject-container]');
        }
      }

      // Fallback again...
      if (!callbackContainerContext.length) {
        // Attempting to find the container from memory.
        if (instances[id]['configuration']['container'].length) {
          callbackContainerContext = instances[id]['configuration']['container'];
        } else {
          AXISDebug.output(3,"Ajax: Failed to recover container context from DOM and Memory.");
        }
      }

      if (callbackContainerContext.length) {
        // Update DOM.
        callbackContainerContext.append(contentBlockSpinnerMarkup(id));
      } else {
        console.log("Ajax: Could not find callback container");
      }
      // If in modal then apply modal lock.
      if (modalContext.length) {
        const modal = AXISModals.toggleModalLock(modalContext, true);
      }
      
    }
  }
  if (isList === true) {
    if (status === false) {
      //Remove block.
      //Static build AJAX spinner delay. (for testing)
      // var delay = Math.floor(Math.random() * 3500) + 100;
      // setTimeout(function () {
      //   $("." + defaultCallBackListContainer).find(".AJAXBlock").remove();
      //   postCounter();
      // }, delay);

      $("." + defaultCallBackListContainer).find(".AJAXBlock").remove();
      postCounter();
    } else if (status === true) {
      //Add block element + spinner.
      $("." + defaultCallBackListContainer).append(contentBlockSpinnerMarkup(id));
    }
  }

  function postCounter() {
    if (postCount > 0) {
      //Once the post is complete decrease the post count.
      postCount--;
    }
  }
}

var instances = {};

function isCallbackActive(id) {
  if (!id) {
    AXISDebug.output(3,"AJAX: No Id provided");
    return false;
  }
  // Check if instance exists.
  if (instances.hasOwnProperty(id)) {
    // Check is-active property if defined.
    if (instances[id].hasOwnProperty('is-active')) {
      return instances[id]['is-active'];
    } {
      // This instance has not called back yet, as the is-active property only gets defined once a callback is performed.
      return false;
    }
  } else {
    AXISDebug.output(3,"AJAX: No instance by that Id");
    return false;
  }
}

// If in the middle of a AJAX request ( i.e waiting for the server to respond ) and the user changes the location on some browsers jQuery will throw and exception causing the fail() callback to pre-maturely fire specifically looking at the Apple environments ( iOS & MacOS ) & Firefox due to them result in a status of 404 but in Windows using Chrome this results in a status of cancelled. 
// This function originated from here https://stackoverflow.com/questions/6910291/change-page-in-the-middle-of-ajax-request
function isUserAborted(xhr) {
  // This may need to be extended to support an empty object.
  return !xhr.getAllResponseHeaders();
}

function doCallback(id) {
  // Get configuration.
  let instanceConfig = instances[id]['configuration'];
  let url = instanceConfig['url'];
  let data = instanceConfig['data'];
  let dataType = instanceConfig['data-type'];
  let method = instanceConfig['method'];
  let context = instanceConfig['context'];
  let isList = instanceConfig['is-list'];
  let captchaToken = instanceConfig['captcha-token'];
  let observerTarget = instanceConfig['observer-target'];
  let enctype = instanceConfig['enctype'];
  let isMultipartForm = instanceConfig['is-multipart-form'];
  let container = instanceConfig['container'];
  let xhrFields = instanceConfig['xhr-fields'];

  let postPromise = new Promise(function (resolve, reject) {
    // Check whether there is already a callback in action.
    if (instances[id]['is-active'] && !instances[id]['configuration']['ignore-active-callbacks']) {
      reject("AJAX: There is already have a callback in process for this, please be patient");
      return false;
    }
    // If this is a recaptcha form.
    if (instances[id]['configuration']['captcha-required']) {
      if (captchaToken) {
        if (isMultipartForm) {
          data.append("g-recpatcha-response", captchaToken);
        } else {
          data = data + "&g-recaptcha-response=" + captchaToken;
        }
      } else if (captchaToken == null) {
        reject('Cancelling callback due to form not having a valid recaptcha token.');
        return false;
      }
    }
    // Check if disabled if so then reject promise.
    if (context.attr('disabled') || context.hasClass('is-invalid')) {
      reject("AJAX: input / form you're trying to submit is either disabled or invalid, terminating callback");
      return false;
    }

    if (AXISDebug.level() >= 3) {
      AXISDebug.output(1,"Ajax: This is the configuration of the callback you're about to send: ", instances[id]);
    }

    // Worth a read if you're having issues sending multipart data: https://stackoverflow.com/questions/5392344/sending-multipart-formdata-with-jquery-ajax
    // Prepare postback.
    var request = $.ajax({
      method: method,
      beforeSend: () => {
        // Check if content block is already applied.
        if (!container.has('div.AJAXBlock').length) {
          // Applied content block.
          ajaxUiToggleBlocker(id);
        }
        // Store menu children states ( which options are open ), this was specifically implemented for product listing filters but can be extended in the future to be more generic.
        let responsiveMenus = $('[data-axis-responsive-menu]');
        if (responsiveMenus.length) {
          responsiveMenus.each(function() {
            let menu = $(this);
            // Does this menu have remember position attribute defined.
            let rememberPosition = menu.attr('data-restore-last-position');
            // Get the id.
            let menuId = menu.attr('id');
            // Fallback for old functionality.
            if (menuId == "filters") {
              rememberPosition = true;
            }
            if (menuId && rememberPosition != undefined) {
              // Store the current active filters in an object.
              AXISResponsiveMenu.getActiveSubmenu(menuId);
              // Store the scroll position.
              AXISResponsiveMenu.getListScrollPosition(menuId, ["#appliedFilters"]);
            }
          });
        }
        postCount++;
        // instances[id]['is-active'] = true;
        setCallbackActive(id);
      },
      url: url,
      data: data,
      dataType: dataType,
      contentType: (isMultipartForm ? false : enctype), // If multipart form then this needs to be set to false otherwise jQuery doesn't assign the boundary string.
      processData: (isMultipartForm ? false : true), // If multipart form then this needs to be set to false otherwise jQuery will convert your data into a string.
      async: true, // This needs to be true otherwise if false will prevent the ajaxUiToggleBlocker from updating the DOM which is more noticable on callback's that require quite a bit of time due to callback running synchronously.
      xhrFields: (xhrFields ? xhrFields : {})
    }).fail((jqXHR, textStatus, errorThrown) => {
      // instances[id]['is-active'] = false;
      setCallbackInactive(id);
      // Check if user has change location ( i.e moved to another page )
      if (isUserAborted(jqXHR)) {
        if (AXISDebug.level() >= 3) {
          AXISDebug.output(3,"AJAX: User interrupt callback request to server.", context);
        }
        resolve({'text-status': textStatus, xhr: jqXHR});
      } else {
        if (AXISDebug.level() < 1) {
          console.error("Something went wrong, enable JS debug mode to view more info.")
        } else if (AXISDebug.level() >= 1) {
          AXISDebug.output(3, errorThrown);
        }
        //Use error handler to format the error.
        errorHandler(jqXHR);
        // Pass error back.
        reject(jqXHR);
      }
    }).done((data, textStatus, jqXHR ) => {
      // instances[id]['is-active'] = false;
      setCallbackInactive(id);
      // If a new location is provided dont follow the usual process and update the dom, yes this would have been better being implemented using the JSON update mechanism.
      //let location = $(data).attr(expressSelectors()['axis-location']['initialise']);
      // Initialise jQuery object.
      let jQueryData;

      // Try and create jQuery selector.
      try {
        jQueryData = $(data);
      } catch(error) {
        // Just resolve as this is clearly not a response that can be used with jQuery ( i.e plain text ).
        resolve({data: data, 'text-status': textStatus, xhr: jqXHR});
      }

      let location = undefined;
      // Make sure this is a jQuery object before do something jQuery related.
      if (typeof(jQueryData) == "object" && jQueryData instanceof jQuery) {
         // Look in response data for data-update-location.
        location = jQueryData.find('[' + expressSelectors()['axis-location']['initialise'] + ']').attr(expressSelectors()['axis-location']['initialise']);
        // Fallback if data-update-location is the only thing in the response ( essentially already in context ).
        if (!location) {
          location = jQueryData.attr(expressSelectors()['axis-location']['initialise']);
        }
        // Fallback to the old way of thinking.
        if (!jQueryData.length) {
          location = instances[id]['configuration']['context'].attr('data-destination');
        }
      }
      
      // If a update location instance has been provided then redirect using the string or redirect to the current page if the string is empty otherwise resolve the callback and continue with re-initialising the content.
      if (location != undefined) {
        // If a location has been provided then go to that location.
        if (location) {
          window.location.href = location;
          // Pass location into instance config.
          instanceConfig['location'] = location;
        } else {
          // Redirect to current location ( i.e reload the page )
          window.location.href = window.location.href;
        }
      } else {
        // TODO: Now that we're starting to use JSON more it would be a good idea to detect at this stage using the response header if a response is json then parse the data string as the response from vm may not be a valid object, a utlity function has been created parseJSON which can handle this.
        resolve({data: data, 'text-status': textStatus, xhr: jqXHR});
      }
    }).always((data, textStatus, xhr) => {
      // Does this element still have active callbacks?
      let activeStatus = getCallbackActiveStatus(id);
      // Get active status.
      let isActive = activeStatus['is-active'];
      //let redirectUrl = context.data('destination');
      // let redirectUrl = context.attr(expressSelectors()['axis-location']['initialise']);
      // Check whether there was a new location provided.
      let location = (instanceConfig.hasOwnProperty('location') ? instanceConfig['location'] : false);

      // If a new location has not been provided.
      if (!location && !isActive) {
        ajaxUiToggleBlocker(id);
      }
      // Configuration that get applied to ALL mutation observers.
      let observerConfig = {childList: true, subtree: true};
      // Essentially an instance obj to obervers.
      let observers = {};
      // Check if this is a JSON response.
      let isJson = isResponseJSON(xhr);
      // If this is a JSON response then skip over initialisation and let the update() function handle this.
      if (!isJson) {
        // Initialise default observers.
        // Add the ajax callback content container to the observers instance obj.
        // Add default if not updating an element outside of the original container.
        if (!observerTarget.length) {
          observers["E10"] = {};
          observers["E10"]['target'] = instances[id]['configuration']['container'][0];
        }
        // If any custom observers are defined then initialise them.
        if (observerTarget) {
          $.each(observerTarget, function(key, value) {
            // Unique Id.
            let observerId = generateId();
            // Get target context ( no jQuery ).
            let target = document.getElementById(value);
            // Create new instance.
            observers[observerId] = {};
            // Assign target.
            observers[observerId]['target'] = target;
          });
        }
        $.each(observers, function(key, value) {
          // Create mutation observer.
          let mutation = new MutationObserver(function(mutationList, observer) {
            // Check if container exists before initialising as the mutation may have been its removal.
            if (document.contains(value['target'])) {
              initialiseScripts(mutationList, observer, key, id, value['target']);
            }
          });
          // Observer!.
          mutation.observe(value['target'],observerConfig);
          // Assign mutation to instance.
          observers[key]['mutation-observer'] = mutation; 
        });
        if (AXISDebug.level() >= 3) {
          AXISDebug.output(1,"AJAX: Here is the list of initialised observers:", observers);
        }
      } else {
        if (AXISDebug.level() >= 3) {
          AXISDebug.output(1,"AJAX: Skipping JS Initialisation in Ajax promise leaving it to update() to handle initialisation of new content");
        }
      }
      // Initialisation function this will initialise various express js components / libraries for the new content.
      function initialiseScripts(mutationList, observer, oberserverKey, uid, container) {
        if (AXISDebug.level() >= 3 ) {
          AXISDebug.output(1,"AJAX: " + mutationList.length + " elements have been updated, here are the elements",mutationList);
        }
        // Check if url needs updating.
        //let container = instances[id]['configuration']['container'];
        //let containers = [];
        // Push the callback container that is wrapped around the content that did the callback.
        //containers.push(container[0]);
        // Loop through the custom containers.
        // if (observerTarget) {
        //   $.each(observerTarget, function(key, value) {
            // Push to containers array & create jQuery object.
            //containers.push(document.getElementById(value));
        //   });
        // }
        // console.log("re-initialise", containers);
        reInitialiseJs(container);

        let focusElementId = instances[id]['configuration']['response-focus-element-id'];
        if (focusElementId) {
          // Focus element context.
          let focusElement = $('#' + focusElementId);
          if (focusElement.length) {
            if (!getViewPort(focusElement)) {
              // Set timeout to clear any animations.
              setTimeout(() => {
                Foundation.SmoothScroll.scrollToLoc(focusElement, {threshold: 50,offset: (getHeaderSize() + 100)});
              }, 100);
            }
            // Focus on element.
            focusElement.trigger('focus');
          }
        }

        // Check if id exists.
        if (instances.hasOwnProperty(id)) {
          // Trigger initialise event.
          $(document).trigger('ajax-content-initialise', {'instance-id': id});
          // Intialise recaptcha.
          if (instances[id]['configuration']['captcha-required']) {
            if (AXISDebug.level() >= 3) {
              AXISDebug.output(1,"AJAX: Re-initialising recaptcha.");
            }
            // Get callback container.
            let container = instances[id]['configuration']['container'];
            if (container.find('form[data-captcha-type]').length == 0) {
              AXISDebug.output(2,"AJAX: This callback previously required captcha verification but now does not is this expected?");
            }
            container.find('form[data-captcha-type]').each(function() {
              let form = $(this);
              // Check if form need initialising.
              if (!form.attr('data-captcha-id')) {
                if (AXISDebug.level() >= 4) {
                  AXISDebug.output(1, "AJAX: Form " + form.attr('id') + " needs to be re-initialised after callback.");
                }
                axisCaptcha.initialise(form);
              }
            });
          }
        }
        //  Remove observer as it's no longer needed.
        if (observer) {
          observer.disconnect();
        }
      }
    });
  });
  return postPromise;
}

function getCallbackActiveStatus(id) {
  if (!id) {
    AXISDebug.output(3,"AJAX: Cannot get active status due to no instance id being provided");
    return false;
  }
  // Get active state.
  let active = instances[id]['is-active'];
  // Get callback count.
  let count = (instances[id].hasOwnProperty('callback-count') ? instances[id]['callback-count'] : undefined);
  return {'is-active': active, 'callback-count': count};
}

function setCallbackActive(id) {
  if (!id) {
    AXISDebug.output(3,"AJAX: Cannot set callback active state due to no instance id provided");
    return false;
  }
  // Get callback count.
  let count = (instances[id].hasOwnProperty('callback-count') ? instances[id]['callback-count'] : 0);
  // Increment count.
  count++;
  // Update instace.
  instances[id]['callback-count'] = count;
  // Update instance active flag.
  let active =  instances[id]['is-active'] = true;
  // Return active state & callback count.
  return {'is-active': active, 'callback-count': count};  
}

function setCallbackInactive(id) {
  if (!id) {
    AXISDebug.output(3,"AJAX: Cannot set callback inactive state due to no instance provided");
    return false;
  }
  // Get callback count.
  let count = (instances[id].hasOwnProperty('callback-count') ? instances[id]['callback-count'] : undefined);
  if (!count) {
    AXISDebug.output(3,"AJAX: Could not find callback count, this implies there was no previous callback or setCallbackActive was never called", id);
    return false;
  }
  // Deincrement count.
  count--;
  // Update instace.
  count = instances[id]['callback-count'] = count;
  // Determine if callbacks are still active.
  let active = (count > 0 ? true : false);
  if (!active) {
    // Update instance active flag.
    active = instances[id]['is-active'] = false;;
  }
  // Return active state & callback count.
  return {'is-active': active, 'callback-count': count};
}

$(window).on('beforeunload', function() {
  // Flag is used to determine if a callback request is currently active, if true then ask the user for confirmation before leaving.
  let promptBeforeUnload = false;
  // Loop over instances.
  for (let [key, value] of Object.entries(instances)) {
    // Skip check even if there active callbacks.
    let ignoreActiveUnloadPrompt = instances[key]['configuration']['ignore-active-unload-prompt'];
    let ajaxInstanceActive = (value.hasOwnProperty('is-active') ? value['is-active'] : false);
    if (ajaxInstanceActive && !ignoreActiveUnloadPrompt) {  
      if (AXISDebug.level() >= 3) {
        AXISDebug.output(3,"AJAX: A callback is active " + key + ", make user confirm before leaving.");
      }
      promptBeforeUnload = ajaxInstanceActive;
      break;
    }
  }
  // If a callback instance is active then use default browser alert to make sure they want to leave, this could be extended to use our own modal system down the line is needed.
  if (promptBeforeUnload) {
    return false;
  }
});


function reInitialiseJs(containers) {
  // console.log("INITIALISE JS", containers);
  // Get the required components.
  // Make sure containers is a jQuery obj.
  $(containers).each(function(key, container) {
    components.initialise($(container)).then((response) => {
      if (AXISDebug.level() >= 3) {
        AXISDebug.output(1,response['message'], (response['components']) ? response['components'] : '');
      }
    });
  });
  // Get component list.
  // TODO: Loop through selectors?
  // Get express selectors.
  let selectors = expressSelectors();
  // for (let selector in selectors) {
  //   //console.log(selector);

  //   // Check for initialise selector.
  //   let initialiseSelector = (selectors[selector].hasOwnProperty('initialise') ? selectors[selector]['initialise'] : undefined);
  //   // If initialise selector exists.
  //   if (initialiseSelector) {
  //     // Find element.
  //     let element = $(containers).find('[' + initialiseSelector + ']');
  //     console.log(initialiseSelector)
  //     // If component found in the DOM.
  //     if (element.length) {
  //       console.log("component found");
  //     }
  //   }
  // }
  

  if (AXISDebug.level() >= 3) {
    AXISDebug.output(1,"AJAX: Attempting to run initialisation's for the following containers:", containers);
  }

  // Check to see if we need to send analytics events.
  const analyticsEvents = $(containers).find('[' + expressSelectors()['analytics']['send-event'] + ']');
  if (analyticsEvents.length > 0) {
    analyticsEvents.each(function() {
      const element = $(this);
      const event = axisGTM.jQueryTriggerEvent(element);
    });
  }

  // Do we need to redirect? 
  let redirect = $(containers).find('[' + expressSelectors()['redirect']['url'] + ']');
  if (redirect.length > 0) {
    // Do redirect.
    AXISRedirect.redirect(redirect);
  }

  // Don't use this use JSON to update various elements on the page instead of a html response.
  // Check the response to see if there is content that needs to be updated else where in the dom.
  let updateContent = $(containers).find('[' + expressSelectors()['ajax']['update-content'] + ']');
  if (updateContent.length > 0) {
    updateContent.each(function() {
      // Grab context.
      let context = $(this);
      // Context of content in the response that needs to be updated.
      let content = context.html();
      if (!content) {
        AXISDebug.output(3,"Update Content: Could not find content");
        return false;
      }
      console.log("Update content: The content we're about to move: ", content);
      // Get the Id of the content we're about to update.
      let updateContentId = context.attr(expressSelectors()['ajax']['update-content']);
      console.log("Update content: The Id of the element we're about to update: ", updateContentId);
      // Find the content to be updated.
      let element = $('#' + updateContentId);
      // If the element cannot be found then exit.
      if (!element) {
        AXISDebug.output(3,"Update Content: Could not find element in the DOM to update", element);
        return false;
      }
      console.log("Update content: The element that we're about to update with the new content: ", element[0]);
      // Update element.
      element.html(content);     
      // Initialise new content.
      reInitialiseJs(element);
    });
  }

  // Redirect.
  let redirectUrl = $(containers).find('[' + expressSelectors()['axis-location']['initialise'] + ']');
  if (redirectUrl.length) {
    redirectUrl.each(function() {
      // Get context.
      let location = $(this);
      // Get the url.
      let url = location.attr(expressSelectors()['axis-location']['initialise']);
      if (url) {
        // Update url.
        window.location.href = url;
      } else {
        AXISDebug.output(3,"Axis Destination: Could not redirect due to no url provided.", location);
      }
    });
  }

  // If there are any time count downs like delivery cut off times.
  // let countdowns = $(containers).find(expressSelectors()['countdown']);
  // if (countdowns.length > 0) {
  //   countdowns.each(function() {
  //     // Context.
  //     let countdown = $(this);
  //     // Initialise countdown.
  //     countdown = AXISCountdown.initialise(countdown);
  //   });
  // }

  // Check if response has update breadcrumbs.
  let updateBreadcrumbs = $(containers).find('[' + expressSelectors()['ajax']['update-breadcrumbs'] + ']');
  if (updateBreadcrumbs.length > 0) {
    // Get new content.
    updateBreadcrumbs = updateBreadcrumbs.children();
    // Update old content.
    $('.breadcrumbs').not('[' + expressSelectors()['ajax']['update-breadcrumbs'] + '] .breadcrumbs').html(updateBreadcrumbs);
  }

  // Content refresh start.
  const contentRefreshStart = $(containers).find('[' + expressSelectors()['content-refresh']['start'] + ']');
  if (contentRefreshStart.length) {
    contentRefreshStart.each(function() {
      const element = $(this);
      // Find parent.
      const refreshElement = element.parents('[' + expressSelectors()['content-refresh']['initialise'] + ']');
      if (refreshElement.length) {
        // Get instance id.
        const refreshId =  refreshElement.attr(expressSelectors()['content-refresh']['initialise']);
        contentRefresh.startTimer(refreshId);
      } 
    });
  }

  // Content refresh stop.
  const contentRefreshStop = $(containers).find('[' + expressSelectors()['content-refresh']['stop'] + ']');
  if (contentRefreshStop.length) {
    contentRefreshStop.each(function() {
      const element = $(this);
      // Find parent.
      const refreshElement = element.parents('[' + expressSelectors()['content-refresh']['initialise'] + ']');
      if (refreshElement.length) {
        // Get instance id.
        const refreshId =  refreshElement.attr(expressSelectors()['content-refresh']['initialise']);
        contentRefresh.stopTimer(refreshId);
      }
    });
  }

   // Initialise modules that need to be equalised.
   // We stopped using this in favour of our own equaliser.
  //  let modulesEqualise = $(containers).find(expressSelectors()['modules']['equalise-modules']);
  //  if (modulesEqualise.length > 0) {
  //    modulesEqualise.each(function() {
  //      // Context.
  //      let module = $(this);
  //      // Initialise.
  //      let init = AXISModules.initialiseEqualisation(module);
  //    });
  //  }
   // Check if a table exists.
   if ($(containers).find('table').length > 0) {
    $(containers).find('table').each(function() {
      // Context.
      let table = $(this);
      // Add in mobile labels.
      let labels = AXISTypography.initialise(table);
    })
  }

  // Any text columns that need their values equalised.
  // let tableTextEqualiserContent = $(containers).find('.text-container, [' + expressSelectors()['text-equaliser']['initialise'] + ']');
  // if (tableTextEqualiserContent.length > 0) {
  //   tableTextEqualiserContent.each(function() {
  //     // Context.
  //     let tableText = $(this);
  //     // Init.
  //     let init = tableTextEqualiser.initialise(tableText)
  //   });
  //   // Not ideal this could do with being completely reworked it was never intended for multi-table instance support + ajax but needed a get out of jail for the call portal.
  //   tableTextEqualiser.applyTextEqualise();
  // }

  let tableColumnEqualiserInstances = $(containers).find('table:has([' + expressSelectors()['axis-table-column-equaliser']['initialise'] + '], .text-container)');
  if (tableColumnEqualiserInstances.length) {
    tableColumnEqualiserInstances.each(function() {
      // Context.
      let equaliseInstance = $(this);
      // Init.
      let init = AXISTableColumnEqualiser.initialise(equaliseInstance);
    });
  }

  // Add in disabled inputs functionality.
  AXISInputs.disabledButtonsInitialise($(containers));

  // Does the new content have grouped inputs?
  let groupedInputs = $(containers).find('[' + expressSelectors()['forms']['input-group-id'] + ']');
  if (groupedInputs.length > 0) {
    groupedInputs.each(function() {
      // Group context.
      let group = $(this);
      // initialise.
      AXISInputs.groupedInputsInitialise(group);
    });
  }

  // Control inputs.
  let controlInputs = $(containers).find('.control');
  // If inputs exist.
  if (controlInputs) {
    controlInputs.each(function() {
      // Grab context.
      let input = $(this);
      // Initialise.
      let initalise = AXISInputs.initialiseControlInputs(input);
    });
  }
  let randomInputValue = $(containers).find('[' + expressSelectors()['forms']['input-unique-value'] + ']');
  if (randomInputValue.length) {
    // Re-initialising all as this will most likely only ever be used in the context of the static.
    AXISInputs.inputsUniqueValue();
  }

  // Sliders.
  let sliders = $(containers).find(expressSelectors()['slider']['initialise']);
  if (sliders.length > 0) {
    sliders.each(function() {
      // Slider context.
      let item = $(this);
      // Initialise.
      let initialise = AXISSliders.initialise(item);
    })
  }

  // Initalise any quantity selectors.
  let quantitySelectors = $(containers).find(expressSelectors()['quantity-selector']['initialise']);
  if (quantitySelectors.length > 0) {
    quantitySelectors.each(function() {
      // Context
      let selector = $(this);
      // Initialise.
      let init = AXISQuantitySelectors.initialise(selector);
    })
  }

  // Initialise stock indicators.
  let indicators = $(containers).find(expressSelectors()['stock-indicators']['initialise']);
  if (indicators.length > 0) {
    indicators.each(function() {
      // Context.
      let stockIndicator = $(this);
      // Initialise.
      let init = stockIndicators.initialise(stockIndicator);
    })
  }

  // If update stock indicator.
  let indicatorsUpdate = $(containers).find('[' + expressSelectors()['stock-indicators']['update'] + ']');
  if (indicatorsUpdate.length > 0) {
    indicatorsUpdate.each(function() {
      // Grab context.
      let indicatorUpdate = $(this);
      // Update.
      let update = stockIndicators.update(indicatorUpdate);
    });
  }

  // Form validation.
  // Does the container contain a form? 
  let forms = $(containers).find('form');
  if (forms.length) {        
    // Loop through forms
    forms.each(function() {
      // Store context.
      let form = $(this);
      // Is this an abide form? 
      let isAbide = (form.attr('data-abide') != undefined ? true : false);
      // Does any of these forms have the auto submit attribute.
      let isAutoSubmit = (form.attr('[' + expressSelectors()['forms']['auto-submit'] + ']') != undefined ? true : false);
      // Has recaptcha?
      //let hasRecaptcha = (form.attr(expressSelectors()['axis-captcha']['initialise']) != undefined ? true : false);
      // If form validation is active then initialise.
      if (isAbide) {
        AXISInputs.validationInitialise(form);
      }
      // Don't need to do this as this is handled by the component loader.
      // if (hasRecaptcha) {
      //   // Initialise recaptcha.
      //   axisCaptcha.initialise(form);
      // }
    });
  } else {
    // Fallback as this response maybe inside of a form that needs to be re-initialised.
    forms = $(containers).parents('form');
    if (forms.length) {
      let isAbide = (forms.attr('data-abide') != undefined ? true : false);
      if (isAbide) {
        AXISInputs.revalidate(forms);
      }
    }
    
  }

  // Auto submit inputs

  let autoSubmitSelector = expressSelectors()['forms']['auto-submit'];

  let autoSubmitInputs = $(containers).find('input[' + autoSubmitSelector + '], select[' + autoSubmitSelector + '], textArea[' + autoSubmitSelector + '], form[' + autoSubmitSelector + '], a[' + autoSubmitSelector + ']');
  // If exists then initialise.
  if (autoSubmitInputs) {
    autoSubmitInputs.each(function() {
      // Grab context.
      let autoSubmitInput = $(this);
      // Initialise.
      let initialise = autoSubmit(autoSubmitInput);
    });
  }

  // Ellipses.
  let ellipses = $(containers).find('[' + expressSelectors()['ellipsis']['initialise'] + ']');
  if (ellipses) {
    ellipses.each(function() {
      // Grab context.
      let element = $(this);
      // Initialise.
      let init = ellipsis.initialise(element);
    });
  }

  // AJAX Lookups.
  let lookups = $(containers).find(expressSelectors()['lookups']['initialise']);
  if (lookups) {
    lookups.each(function() {
      // Grab context.
      let lookup = $(this);
      // Initialise.
      AXISLookups.initialise(lookup);
    });
  }

  // Tooltips.
  let tooltips = $(containers).find(expressSelectors()['tooltip']['initialise']);
  if (tooltips) {
    tooltips.each(function() {
      // Grab context.
      let tooltip = $(this);
      // Initialise.
      AXISTooltip.initialise(tooltip);
    });
  }

  // Callouts.
  let calloutElements = $(containers).find('[' + expressSelectors()['callouts']['initialise'] + ']');
  if (calloutElements) {
    calloutElements.each(function() {
      // Grab context.
      let callout = $(this);
      // Message.
      let message = callout.html();
      // Delay.
      let delay = callout.attr(expressSelectors()['callouts']['delay']);
      // Get the callout type ( i.e success, warning or alert ).
      let type = callout.attr(expressSelectors()['callouts']['type']);
      // Fallback to success.
      if (type == undefined) {
        type = 0;
      }  
      // Create callout.
      let create = callouts.create(message, type, "side", delay);
    });
  }

  // Equalisable content.
  let equaliseContent = $(containers).find('[' + expressSelectors()['equaliser']['initialise'] + ']');
  if (equaliseContent) {
    equaliseContent.each(function() {
      // Grab context.
      let content = $(this);
      // Initialise.
      let init = equaliser.initialise(content);
    });
  }

  // Initialise any sticky elements.
  let stickyContent = $(containers).find('[' + expressSelectors()['axis-sticky']['initialise'] + ']');
  if (stickyContent) {
    AXISSticky.instancesCleanup();
    stickyContent.each(function() {
      // Grab context.
      let context = $(this);
      // Initialise.
      let init = AXISSticky.initialise(context);
    });
  }

  // Open modal.
  let openModal = $(containers).find('[' + expressSelectors()['modals']['open-modal'] + ']');
  if (openModal.length) {
    openModal.each(function() {
      // Context.
      let context = $(this);
      // Modal Id.
      let modalId = context.attr(expressSelectors()['modals']['open-modal']);
      if (!modalId) {
        console.error("Modals: No Id defined.");
        return false;
      }
      // Try and find it in the DOM.
      let modal = $('[' + expressSelectors()['modals']['modal-context'] + '="' + modalId + '"]');
      if (!modal.length) {
        console.error("Modals: Could not find modal in DOM", modal);
        return false;
      }
      // Build custom config.
      let customConfig = {};
      // If url detected then add it.
      let url = context.attr(expressSelectors()['ajax']['url']);
      if (url) {
        customConfig['url'] = url;
      }
      // Trigger modal.
      AXISModals.open(modal, customConfig);
    })
  }

  // Close modals.
  let closeLastUsedModal = $(containers).find('[' + expressSelectors()['modals']['close-modal'] + ']');
  if (closeLastUsedModal.length > 0) {
    closeLastUsedModal.each(function() {
      // Close trigger context.
      let close = $(this);
      // Modal Id.
      let modal = close.attr(expressSelectors()['modals']['close-modal']);
      // Close last used modal.
      AXISModals.modalClose(modal);
      // Remove it.
      close.remove();
    });
  }

  // Initialise any modals.-
  let modals = $(containers).find('.modal-container');
  if (modals) {
    modals.each(function() {
      // Grab context.
      let context = $(this);
      // Initialise.
      let init = AXISModals.initialise(context);
    });
  }

  // TODO: this needs to use the new initialise mechanism.
  // Initialise reviews.
  // let reviewsInstances = $(containers).find('[' + expressSelectors()['axis-reviews']['initialise'] + ']');
  // if (reviewsInstances) {
  //   reviewsInstances.each(function() {
  //     // Get context.
  //     let context = $(this);
  //     // Initialise.
  //     let init = axisReviews.initialise(context);
  //   });
  // }

  // Find any responsive menus.
  let responsiveMenus = $(containers).find('[data-axis-responsive-menu]');
  if (responsiveMenus.length) {
    responsiveMenus.each(function() {
      let menu = $(this);
      AXISResponsiveMenu.initialise(menu);
    });
  }

  // Hacky but this will need to re-write to be more generic.
  let productList = $(containers).find($('#productListItems'));
  if (productList.length) {
    productList.each(function() {
      let list = $(this);
      AXISProductList.initialiseList(list);
    });
  }

  // Initialise foundation + it's plugins.
  $(containers).foundation();   

  // Close notification.
  let notification = $(containers).parents('[data-notification]');
  if (notification) {
    let close = notifications.close(notification);
  }

  // Initialise password reveal.
  let passwordReveals = $(containers).find('input[type=password]');
  if (passwordReveals) {
    passwordReveals.each(function() {
      // Context.
      let passwordField = $(this);
      // Initialise.
      let init = AXISInputs.initialisePasswordReveal(passwordField);
    });
  } 

  // Read more.
  let readMores = $(containers).find(expressSelectors()['axis-read-more']['initialise']);
  if (readMores) {
    readMores.each(function() {
      // Context;
      let readMore = $(this);
      // Initialise.
      let init = AXISReadMore.initialise(readMore);
    });
  }

  // Select the element that should have the updated url.
  let updateUrlElement = $(containers).find('[' + expressSelectors()['update-url'] + ']');
  // If the update url element then set the new url.
  if (updateUrlElement.length > 0) {
    updateUrl.set(updateUrlElement);
  }

  // Check if the container has a basket form in.
  let basketForm = $(containers).find(expressSelectors()['basket']['form']);
  if (basketForm.length) {
    basketForm.each(function() {
      // Initialise basket.
      basketInitialiseForm();
    });
  }
}

// Either assigns or creates an instance to a callback.
function callbackInstance(url, data, dataType, context, isList, method, enctype, isMultipartForm, ignoreActiveUnloadPrompt = false, submitter = undefined, ignoreActiveCallbacks = false, xhrFields = undefined) {
  let id, instanceConfig;
  if (context.attr(expressSelectors()['ajax']['instance']) == undefined) {
    // Generate Id.
    id = generateId();
    // Assign id to dom.
    context.attr(expressSelectors()['ajax']['instance'], id);
    // Find callback container.
    let container = undefined;

    let lookupKey = AXISLookups.getLookupKey(context);
    if (lookupKey) {
      if (context.attr('id')) {
        let lookupContextId = $('[data-ajax-include=' + context.attr('id') + ']').attr('data-ajax-context');
        container = $('#' + lookupContextId);
      }
    } else if (isList) {
      container = context.parents("." + callbackListContainer);
    } else { 
      container = context.parents("." + callbackContainer);
    }
    

    // Defined this is if you need to completely replace the contents or the callback container itself.
    let callbackContainerId = context.attr(expressSelectors()['ajax']['callback-container-id']);
    // TODO: the callback container logic needs to be re-writen and placed somewhere within ajaxUiToggleBlocker as this doesn't hand multiple container being update at the same time very well and multiple nested ajax calbacks (i.e ajax modals with nested ajax forms ). 
    // If a callback container id has been defined.
    if (callbackContainerId != undefined) {
      // Attempt to find container by id.
      container = $('#' + callbackContainerId);
      if (container.length == 0) {
        if (AXISDebug.level() >= 2) {
          AXISDebug.output(2,"AJAX: Failed to find callback container by id " + callbackContainerId);
        }
      }
    }

    // Try and fallback to list container.
    if (!container) {
      container = context.closest(".callbackListContainer");
    }

    // If all else fails then wrap context in a callback container.
    if (container == undefined || container.length == 0) {
      if (!container.length) {
        container = context.parents("." + callbackContainer);
      }

      if (!container.length) {
         AXISDebug.output(1,"AJAX: Could not find ." + callbackContainer + " or ." + callbackListContainer + " wrapped around callback content, automatically triggered fallback that wraps the content inside of a ." + callbackContainer + " to prevent the spinner or captcha from failing.");
        // Fallback.
        container = setResponseCallbackContainer(context);
      }
    } 

    // Check again if still nothing then console log as this may have a negative affect.
    if (container == undefined || container.length == 0) {
      AXISDebug.output(2,"AJAX: Could not find container.");
    }

    // Holds id's of elements that need to be re-initialised after ajax.
    let observerTargetArray = [];

    // // Check whether we're observing any node to initialise after callback.
    // let observerTarget = context.attr(expressSelectors()['ajax']['observer-target']);
    // if (observerTarget) {
    //   // Split string into array just incase there is multiple targets.
    //   observerTarget = observerTarget.split(',');
    //   // Add each item to array.
    //   $.each(observerTarget, function() {
    //     observerTargetArray.push(this);
    //   })
    // }

    // Are we putting the response outside of the .callBackContainer ?
    let responseContainers = context.attr(expressSelectors()['ajax']['response-context']);
    // Fallback.
    if (!responseContainers) {
      responseContainers = context.parents('[' + expressSelectors()['ajax']['response-context'] + ']').attr(expressSelectors()['ajax']['response-context']);
    }
  
    if (responseContainers) {
      if (AXISDebug.level() >= 2) {
        AXISDebug.output(1,"AJAX: Content attribute defined so the response will be outputted in the element(s):", responseContainers);
      }
      // Split string into array just incase there is multiple targets.
      observerTargetArray = responseContainers.split(',');

      // Make sure none of the elements is inside of a callbackContainer otherwise this will cause the response elements to be initialised twice.
      $.each(observerTargetArray, function(key, value) {
        // Context.
        let responseContainer = $('#' + this);
        // Make sure response container is not inside of a callback container.
        if (responseContainer.parents('.' + callbackContainer).length) {
          AXISDebug.output(2,"AJAX: response context " + value + " is inside of a ." + callbackContainer + " this will cause the initialisation to run multiple times");
        }
      });
    }
    // Having to rebuild context of modal trigger(s) here via DOM attributes due to the modal queue array not providing the trigger context as there is many ways a modal can be triggered ( listeners / programatically ).
    // Check for queued modals.
    const modalQueue = AXISModals.getQueue();
    if (modalQueue.length) {
      // Look for modal instances in context.
      let modals = new Array();
      // Check context element itself.
      let checkContext = context.attr(expressSelectors()['modals']['confirm']);
      if (checkContext) {
        modals.push(checkContext);
      }
      // Check inside of the context element.
      let insideContext = context.find('[' + expressSelectors()['modals']['confirm'] + ']');
      if (insideContext) {
        insideContext.filter((key, modal) => modals.push(modal.getAttribute(expressSelectors()['modals']['confirm'])));

      }
      // Loop queue models matching any modals that are no longer valid.
      const queueMatch = modalQueue.filter((queued) => modals.includes(queued['type']));
      // Loop through match
      if (queueMatch) {
        for (const index in queueMatch) {
          const cleared = AXISModals.clearQueue(queueMatch[index]['id']);
          if (cleared) {
            if(AXISDebug.level() >= 3) {
              AXISDebug.output(1,"AJAX: Cleared queued modal", queueMatch[index]['context'])
            }
          }
        }
      }
    }

    // Captcha Type.
    let captchaType = context.attr(expressSelectors()['forms']['validation']['captcha-type']);
    // If a captcha is defined then set this flag to true.
    let captchaRequired = (captchaType != undefined);

    // Content blocker delay.
    let delay = context.attr(expressSelectors()['ajax']['content-blocker-delay']);
    if (!delay && !context.attr('data-ajax') ) {
      if (context.parent('[data-ajax]')) {
        delay = context.parents('[data-ajax]').attr(expressSelectors()['ajax']['content-blocker-delay']);
      }
    }
    // Detect if in modal.
    let modalContext = context.parents('[' + expressSelectors()['modals']['modal-context'] + ']');
    // Check if context is a modal.
    if (!modalContext.length) {
      if (context.attr(expressSelectors()['modals']['modal-context']) != undefined) {
         modalContext = context;
      }
    }
    // Should we focus on an element in the response.
    let focusElementId = context.attr(expressSelectors()['ajax']['response-focus-element-id']);
    // Generate instance.
    instances[id] = {};
    // Add in configuration obj.
    instances[id]['configuration'] = {};
    // Create variable for shorthand config use.
    instanceConfig = instances[id]['configuration'];
    instanceConfig['url'] = url;
    instanceConfig['data'] = data;
    instanceConfig['data-type'] = dataType;
    instanceConfig['context'] = context;
    instanceConfig['container'] = container;
    instanceConfig['is-list'] = isList;
    instanceConfig['method'] = method;
    instanceConfig['observer-target'] = observerTargetArray;
    instanceConfig['enctype'] = enctype;
    instanceConfig['is-multipart-form'] = isMultipartForm;
    // Callback sent flag, used to prevent spamming of the callbacks until the response has been returned.
    instances[id]['is-active'] = false;
    instanceConfig['captcha-type'] = captchaType;
    instanceConfig['captcha-required'] = captchaRequired;
    instanceConfig['content-block-delay'] = (delay ? delay : undefined);
    instances[id]['configuration']['response-focus-element-id'] = focusElementId;
    instanceConfig['ignore-active-unload-prompt'] = ignoreActiveUnloadPrompt
    instanceConfig['submitter'] = submitter;
    instanceConfig['ignore-active-callbacks'] = ignoreActiveCallbacks;
    instanceConfig['xhr-fields'] = (xhrFields ? xhrFields : undefined);
    instanceConfig['modal-context'] = modalContext;
  } else {
    id = context.attr(expressSelectors()['ajax']['instance']);

    if (instances[id] != undefined) {
        // Create variable for shorthand config use.
      instanceConfig = instances[id]['configuration'];

      // TODO: This is potentially the beginning of an ajax caching mechansim.
      // Check whether this callback is different.
      if (instanceConfig['url'] != url) {
        instanceConfig['url'] = url;
      }
      if (instanceConfig['data'] != data) {
        instanceConfig['data'] = data;
      }
      if (instanceConfig['method'] != method) {
        instanceConfig['method'] = method;
      }

    } else {
      AXISDebug.output(3,"AJAX: Could not find instance id in instance object, has this callback been initialised correctly?");
      return false;
    }
    
  }
  return id;
}

var serialiseCount = -1;

function serialise(context, applyExcludes = true, submitter = undefined) {
  // Reset count.
  serialiseCount = -1;
  // Suppressing as we now have forms that merge data from one form to another which will not actually submit to an end point 845740 ( Edit Payer Details ) and then we link forms forms together for final submission.
  // if (context.data('ajax') == undefined && context.attr('action') == undefined) {
  //   context = context.closest('data-ajax');
  // }
  // Put the form into context if it is not already.
  let form = (context.is('form') ? context : context.parents('form'));

  // If we're only serialising active options then go here.
  let activeOptionsOnly =  context.attr(expressSelectors()['forms']['serialise-active-only']);
  if (activeOptionsOnly != undefined) {
    //console.warn("ONLY SERIALISING ACTIVE OPTIONS ONLY");
    return serialiseActiveOptions(context, submitter);
  }


  // Should we include additional context about the form ( labels / sequence )? 
  let includeAdditionalContext = includeAdditionalFormContext(form);
  // Should we exclude a group of inputs?
  let excludes = context.data('reset-group');
  // Find any recaptcha's for lookup and disable then to prevent thier g-recaptcha-response token interfering with the form's captcha response.
  form.find('[name=g-recaptcha-response]').attr('disabled', 'disabled')
  // At this stage we're not interested in what they entered in the lookup fields.
  // [name$=-lookup-key], [name=lookup-address] are magic string that doesn't get used anymore but instead we should be selecting inputs by attrbiutes.
  form.find('[name$=-lookup-key], [name=lookup-address], [' + expressSelectors()['lookups']['lookup-key'] + ']').attr('disabled', 'disabled');
  // Get the data to serialise.
  let data;
  if (applyExcludes && excludes) {
    data = form.find(":input:not(" + excludes + "), input[id!=g-recaptcha-response]").serialize();
  } else if (includeAdditionalContext) {
    if (AXISDebug.level() >= 3) {
      AXISDebug.output(1, "AJAX: Including additional context is enabled labels, sequencing & headings will be sent with the callback");
    }
    // Serialise the form using jQuery serialize.
    data = form.not(":disabled").serialize();
    // Split the data into array.
    let array = data.split('&');


    let a = form.find('input, select, textarea').not(':disabled');

    $.each(a, function(key, element) {
      // Create jQuery object.
      element = $(element);
      // Check whether element is a checkbox.
      if (element.attr('type') == 'checkbox') {
        if (!element.prop('checked')) {
          // Insert into array.
          array.splice(key, 0, element.attr('name') + "=off");
        }
      }
    });

    // Hold the new data string.
    let newFormData = "";
    // Loop through array finding additional context.
    $.each(array, function(key, field) {
      
      let fieldData = formToEmailContext(form, field);
      // If data is returned.
      if (fieldData != undefined) {
        newFormData = newFormData + (newFormData != "" ? "&" + fieldData : fieldData);
      }
    });
    data = newFormData;
  } else {
    data = form.serialize();
  }

  // Should we collect data from another form?
  let additionalForm = context.attr(expressSelectors()['forms']['additional-form']);
  if (additionalForm) {
    // Find additional form.
    let additionalFormContext = $('form[name="' + additionalForm + '"]');
    if (additionalFormContext.length) {
      // If more than one form found pick the first, this was put in place to handle sorting form on listing pages.
      if (additionalFormContext.length > 1) {
        additionalFormContext = additionalFormContext.first();
      }
      // Serialise additional form data.
      let additionalFormData = serialise(additionalFormContext);
      // Add additional form data.
      if (additionalFormData) {
        data = data + "&" + additionalFormData;
      }
    }
  }
  
  // Re-enable fields.
  form.find('[name$=-lookup-key], [name=lookup-address], [data-lookup-key]').removeAttr('disabled');
  form.find('[name=g-recaptcha-response]').removeAttr('disabled');

  return data;
}

// Get the names + values of all the "inputs / options" that are active.
function serialiseActiveOptions(context, submitter = undefined) {
  // Do we serialise ALL options with data-option-active & data-option-active-condiitonal
  let force = false;
  // Check if the element that triggered the submission has data-option-active-force.
  if (submitter) {
    force = (submitter.attr(expressSelectors()['forms']['option-active-force']) != undefined);
    //console.log("Send everything: ", force);
  }
  // Get all options, also get hidden inputs as they maybe required for additional context.
  let options;
  if (force) {
    options = context.find('[' + expressSelectors()['forms']['option-active'] + '],[' + expressSelectors()['forms']['option-active-conditional']  +'],[' + expressSelectors()['forms']['option-active-force'] + '],input[type="hidden"]');
  } else {
    options = context.find('[' + expressSelectors()['forms']['option-active'] + '],[' + expressSelectors()['forms']['option-active-force'] + '],input[type="hidden"]');
  }
  //console.log("options selected:", options);

  // Serialised string that gets returned.
  const data = serialiseOptions(options);
  return data;
}


function serialiseOptions(options) {
  let data = null;
  options.each((index, element) => {
    // Option context.
    let option = $(element);
    // Get the name + value of context + add it to the data string that get returned.
    data = (data ? data + "&" + getCustomNameValuePair(option) : getCustomNameValuePair(option));
  });
  return data;
}

function formToEmailContext(form, field) {
  if (!form) {
    AXISDebug.output(2,"Form To Email: No form context provided");
  }
  if (!field) {
    AXISDebug.output(2,"Form To Email: No field data provided");
  }
  // Extra the name from the value.
  let name = field.substr(0, field.indexOf('='));
  // Get context
  let context = form.find('[name="' + name + '"]');
  // If there is multiple elements with the same name ( i.e. radio button group ).
  if (context.length > 1) {
    if (context.is('input[type="radio"]')) {
      // Find the element that is checked.
      context = context.filter(':checked');
    }
  }
  // Get Value.
  let value = context.val();
  // Get field container.
  let fieldContainer = context.closest('.field');
  // Check whether this is a conditional input.
  let isConditionInput = fieldContainer.parents('[data-conditional-input-container]').length > 0;
  // Set the condition met to true unless proven otherwise.
  let isConditionMet = true;
  // Check whether the condition is met if this is a conditional input.
  if (isConditionInput) {
    isConditionMet = fieldContainer.parents('[data-conditional-input-container]').hasClass('active');
  }
  // If this is a hidden field then skip.
  if (context.attr('type') == 'hidden' && context.attr(expressSelectors()['forms']['input-label']) == undefined) {
    isConditionMet = false
  }
  // If condition met then carry on with the serialisation process.
  if (isConditionMet) {
    serialiseCount++;
    // Get the label.
    let label = context.prev('.label');
    // Get label, we just want the label text not any advisory-text, this solution is based on the answers given here https://stackoverflow.com/questions/3442394/using-text-to-retrieve-only-text-not-nested-in-child-tags .
    if (label.length) {
      label = label[0].childNodes[0].nodeValue;
    }
    // Fallback to attribute.
    if (!label.length) {
      label = context.attr(expressSelectors()['forms']['input-label']);
    }
    // If a label then run through processing it.
    if (label && label.length) {
      // Use the input-label attribute on the input to override the email label.
      let emailLabel = context.attr(expressSelectors()['forms']['input-label']);
      // Force usage of email label override if label is equal to value. e.g. radio buttons typically have the same label as their value as they're grouped.
      if (label == value) {
        // If no email label provided then default back to input name ( i.e. group name ), eventhough not formatted formatted for readability it is still better than outputting the same value twice.
        if (emailLabel) {
          label = emailLabel;
        } else{
          // Default back to input name.
          label = name;
        }
      }
      // If no label then fallback input name.
      if (!label.length) {
        label = "";
      }
      // Get the label ready to be added to the query string.
      label = "data-label-" + name + "=" + encodeURIComponent((emailLabel ? emailLabel : label));
    } else {
      label = "";
    }
    // Get sequence.
    let sequence = serialiseCount;
    // Get sequence ready to be added to query string.
    sequence = "data-sequence-" + name + "=" + sequence;
    // Check whether this field has a heading.
    // Get fieldset context.
    let fieldset = fieldContainer.closest('fieldset');
    // Find out if this is the first field in a field set.
    let isFirst = fieldset.find('.field:first').find(context).length > 0;

    let heading = "", subHeading = "";
    if (isFirst) {
      // Check whether heading exists in field set.
      heading = fieldContainer.siblings('h2:first').text();
      // Check whether sub heading exists.
      subHeading = fieldContainer.siblings('h3:first').text();
    } else {
      if (fieldContainer.prev('h2')) {
        subHeading = fieldContainer.prev('h2:first').text();
      }
      
      if (fieldContainer.prev('h3')) {
        subHeading = fieldContainer.prev('h3:first').text();
      }
    }

    if (heading.length > 0) {
      // Get heading ready to be added to query string.
      heading = "data-heading-1-" + name + "=" + encodeURIComponent(heading);
    }
    if (subHeading.length > 0) {
      // Get sub heading ready to be added to query string.
      subHeading = "data-heading-2-" + name + "=" + encodeURIComponent(subHeading);
    }
    // Piece together field data.
    let fieldData = "";
    // Get field input.
    fieldData = field;
    // Get label.
    fieldData = fieldData + (label.length > 0 ? "&" + label : '');
    // Get sequence.
    fieldData = fieldData + "&" + sequence;
    // Add heading
    fieldData = fieldData + (heading.length > 0 ? "&" + heading : '');
    // Add sub heading
    fieldData = fieldData + (subHeading.length > 0 ? "&" + subHeading : ''); 

    return fieldData;
  } else {
    // Condition on when to just ouput the field value.
    if (context.attr('type') == 'hidden') {
      return field;
    }
  } 
}

// Checks whether we should be including additional information regarding the form fields ( labels & sequence )
function includeAdditionalFormContext(context) {
  // See if context has require data attribute.
  let getAdditionalContext = (context.attr(expressSelectors()['forms']['include-context']) !== undefined);
  return getAdditionalContext;
}


/*

DEPRICATED: Use the setResponseCallbackContainer / getResponseCallbackContainer utlity functions instead.
Gets the callback container.

*/
function getCallbackContainer(context) {
  if (!context) {
    AXISDebug.output(3, "AJAX: Cannot get the callback container due to no context being provided.");
    return false;
  }
  let container = context.closest('.' + callbackContainer);
  // Adding fallback just inscase no callbackContainer can be found.
  if (!container.length) {
    container =  context.parents('form').parent('div');
    if (container.length) {
      AXISDebug.output(2,"AJAX: Could not find ." + callbackContainer + " but form found, defaulting to the parent <div>", context);
    }
  }

  if (container.length == 0) {
    AXISDebug.output(3, "AJAX: Could not find callback container make sure you give the button context.");
    return false;
  }

  // DO NOT DO THIS!!! because if the original content is within a table on the page and the response has a modal in it then the content will be placed inside of the modal.
  // If the previous content was injected into the DOM via a callback then make that the new container.
  // if (container.find('[inject-container]').length > 0) {
  //   container = container.find('[inject-container]');
  // }
  return container;
}

function autoSubmit(context) {
  // Check to make sure context has auto submit.
  if (context.attr(expressSelectors()['forms']['auto-submit']) == undefined) {
    return false;
  }

  let id = context.attr(expressSelectors()['forms']['auto-submit']);
  if (!id) {
    // Assign id so we don't initialise again.
    context.attr(expressSelectors()['forms']['auto-submit'], generateId());
    // Make sure the Id has been updated in the DOM.
    id = context.attr(expressSelectors()['forms']['auto-submit']);
  } else {
    // As we're already initialise skip this element.
    return false;
  }
  
  // Check if this is a form?
  let isForm = context.is('form');
  // Check if is anchor.
  let isAnchor = context.is('a');
  // Add listener.
  context.on('change ' + (isAnchor ? 'click' : ''), function(event) {
    if (isForm) {
      context.trigger('submit');
    } else {
      // Prevent default behavour.
      event.preventDefault();

      let setOptionId = context.attr('data-option-set-variable');

      let setOptionValue = context.attr('data-option-set-value');
      if (setOptionId && setOptionValue) {
        setActiveOptionByValue(setOptionId, setOptionValue);
      }
      // Get the name attribute value from context.
      let groupId = getPairKey(context);
      // Is this an anchor?
      let isAnchor = context.is('a');
      // If active ( i.e Pagination active == disabled ) then exit.
      let isActive = (context.attr(expressSelectors()['forms']['option-active']) != undefined);
      // Fallback.
      if (!isActive) {
        isActive = (context.attr(expressSelectors()['forms']['option-active-force']) != undefined);
      }
      // Only continue if this an acnhor as the rest of this logic is for moving the active state.
      // if (!isAnchor) {
      //   return false;
      // }
      // Get group context.
      let groupContext = $('[name="' + groupId + '"]');
      // Force all options to submit.
      let force = groupContext.is('[' + expressSelectors()['forms']['option-active-force'] + ']');

      if (groupId && isAnchor) {
        // If anchor is part of a group then remove previous active states. 
        // Remove attribute(s).
        if (force) {
          groupContext.removeAttr(expressSelectors()['forms']['option-active-force']);
        } else {
          groupContext.removeAttr(expressSelectors()['forms']['option-active']);
        }
        // Remove Class(s).
        $('[name="' + groupId + '"]').removeClass('active');
        // Add attribute(s) & class(s) to context.
        if (force) {
          context.attr(expressSelectors()['forms']['option-active-force'], '');
        } else {
          // Add active state to context.
          context.attr(expressSelectors()['forms']['option-active'], '');
        }
        context.addClass('active')
      }
      // Trigger form submit.
      context.parents('form').trigger('submit', {submitter: context});
    }
  });

  function setActiveOptionByValue(groupId, value) {
    let optionContext = $('[name="' + groupId + '"]');
    // What type of input are we dealing with here?
    let elementType = "";
    optionContext.each(function() {
      let option = $(this);
      if (option.is('a')) {
        elementType = "anchor";
      } else if (option.is('select')) {
        elementType = "select";
      } else if (option.is('input')) {
        elementType = "input"
      } else {
        console.log("Unsupported element");
        return false;
      }
    });


    if (elementType == "anchor") {
      // Before submitting if this item is part of a option-active group then find the other active element in this group and de-activate them.
      $('[name="' + groupId + '"][' + expressSelectors()['forms']['option-active'] +  ']').removeAttr(expressSelectors()['forms']['option-active']).removeClass('active');
    }
    
    let forms, elements;
    switch(elementType) {
      case "anchor": 
        // Find anchor.
        elements = $('[name="' + groupId + '"][value="' + value + '"]');

        let forms = elements.parents('form');
        forms.each(function() {
          // Form context.
          let form = $(this);
          // Find first elmeent.
          let element = form.find(elements).first();
          element.attr(expressSelectors()['forms']['option-active'], '');
          element.addClass('active');
        });
        break;
      case "select":
        // Find select.
        elements =  $('[name="' + groupId + '"]');
        forms = elements.parents('form');
        forms.each(function() {
          // Form context.
          let form = $(this);
          // Find first elmeent.
          let element = form.find(elements).first();
          element.val(value);
        });
        break;  
      case "input":
        // Find inputs.
        elements =  $('[name="' + groupId + '"]');
        forms = elements.parents('form');
        forms.each(function() {
          // Form context.
          let form = $(this);
          // Find first elmeent.
          let element = form.find(elements).first();
          if (element.is('input[type="checkbox"]')) {
            if (value == "true") {
              element.prop('checked', true);
            } else {
              element.prop('checked', false);
            }
          } else {
            console.error("Input type not supported");
          }
        });
        break;
    }
  }

  // Check if context is an anchor? 
  // if (context.is('a')) {
  //   // Then add click listener, this is fundimental to how list sorting works.
  //   context.on('click', function(event) {
  //     // Prevent default behavour.
  //     event.preventDefault();
  //     // Get the name attribute value from context.
  //     let groupId = getPairKey(context);
  //     // If active ( i.e Pagination active == disabled ) then exit.
  //     let isActive = (context.attr(expressSelectors()['forms']['option-active']) != undefined);
  //     if (isActive) {
  //       return false;
  //     }
  //     if (groupId) {
  //       // Before submitting if this item is part of a option-active group then find the other active element in this group and de-activate them.
  //       $('[name="' + groupId + '"][' + expressSelectors()['forms']['option-active'] +  ']').removeAttr(expressSelectors()['forms']['option-active']).removeClass('active');
  //       // Add active state to context.
  //       context.attr(expressSelectors()['forms']['option-active'], '');
  //       context.addClass('active')
  //     }

  //     // Trigger form submit.
  //     context.parents('form').trigger('submit');
  //   });
  // }
  // Make sure change listener has been applied.
  if ($._data(context.get(0), "events").change) {
    return context;
  } else {
    return false;
  }
}

function getCallbackLocation(context) {
  // Store the callback location ( the url );
  let location;
  // Work out whether the context has data-ajax or a href.
  if (context.attr('data-ajax') != undefined && context.attr('data-ajax') != "") {
    location = context.attr('data-ajax');
  } else if (context.is('form')) {
    location = context.attr('action');
  } else {
    location = context.attr('href');
  }

  // Attempt to fallback.
  let fallbackForm = context.parents('form');
  // If no location is found then see if context is wrapped in a form.
  if (location == undefined || location == "#" || location == "" && fallbackForm.length > 0) {
    // If in form then take the location from its data-ajax or href.
    if (fallbackForm.attr('data-ajax')) {
      location = fallbackForm.attr('data-ajax');
    } else {
      location = fallbackForm.attr('action');
    }
  } 

  if (location == undefined || location == "" || location == "#") {
    AXISDebug.output(2,"AJAX: Failed to obtain callback location, this can be ignored if using custom config");
  }

  return location;
}

// Allow a custom name + value pair to be submitted along side the callback payload.
function getCustomNameValuePair(context) {
  let key = getPairKey(context);
  if (key) {
    let value = getPairValue(context);
    if (value) {
      return key + "=" + value;
    } else {
      return key + "=" + "";
    }
  } else {
    return false;
  }
}
// Function primarily used for getCustomNameValuePair.
function getPairKey(context)  {
  let name = context.attr('name');
  return name;
}

// Function primarily used for getCustomNameValuePair.
function getPairValue (context){
  let value = context.prop('value');
  if (context.is('input[type="checkbox"]')) {
    value = context.prop('checked');
  }
  // Fallback.
  if (value == undefined) {
    // If context is not an input jQuery val() will not pick up the value attribute.
    value = context.attr('value');
  }
  // As a last resort.
  if (value == undefined) {
    value = '';
  }
  return encodeURIComponent(value);
}

function getOperation(context, isMultipartForm = false) {
  let operation = context.attr(expressSelectors()['ajax']['operation']);
    // If no operation defined then fallback to the name.
    // if (operation == undefined) {
    //   operation = context.attr('name');
    // }

  if (operation) {
    if (isMultipartForm) {
      return encodeURIComponent(operation);
    } else {
      return operation = "operation=" + encodeURIComponent(operation);
    }
    
  } else {
    return false;
  }
}


// Check if context is already jQuery object, this is because this function used to work based on an elements id but then go change to work with a jQuery object.
function jQueryContextCheck(context) {
  if (context != undefined && context != "") {
    let formId;
    // Checks if the id has already been extracted into a string or that a jQuery object has been passed into the function.
    if (typeof context === 'object') {
      formId = document.getElementById(context.attr('id'));
    } else {
      formId = document.getElementById(context);
      context = $('#' + context);
    }
    // If the form is being validated by abide.
    if ((formId != null || formId != undefined) && (formId.hasAttribute('data-abide'))) {
      // If the form is invalid then reject the the promise.
      if (context.hasClass('is-invalid')) {
        reject(formId.id + " form is invalid.");
        return false;
      }
    }

    return context;
  } else {
    if (AXISDebug.level() >= 2) {
      AXISDebug.output(2,"AJAX: As a general rule of thumb you should always pass in the DOM element as context of what you're calling back for, otherwise it will break things such as the ui blocking mechanism / ajax spinner or re-initialiations.")
    }
    return false;
  }
}

// Specifically for loading in javascript file from server then executes it.
function getScript(url, integrity, crossOrigin) {


  // Additional attributes.
  const scriptAttrs = new Object();
  // If Subresource Integrity ( SRI ) check is required then add the hash as an additional attribute.
  if (integrity.length) {
    scriptAttrs['integrity'] = integrity;
  }
  // If strong CORS then you will need to specify the crossorigin attribute as well.
  if (crossOrigin.length) {
    scriptAttrs['crossorigin'] = crossOrigin;
  }

  return new Promise((resolve, reject) => {
    let request = $.ajax({
      method: 'GET',
      url: url,
      dataType: 'script',
      cache: true,
      async: false,
      scriptAttrs: scriptAttrs
    }).fail((error) => {
      if (AXISDebug.level() < 1) {
        console.error("Something went wrong, enable JS debug mode to view more info.")
      } else if (AXISDebug.level() >= 1) {
        AXISDebug.output(3, error);
      }
      //Use error handler to format the error.
      errorHandler(error);
      reject(error);
    }).done((script, textStatus, jqxhr ) => {
      resolve(textStatus);
    });
  });
}

// Get callback method.
function getMethod(context) {
  let method = context.attr('method');
    // Fallback.
    if (!method) {
      method = context.attr(expressSelectors()['ajax']['method']);
      // Fallback #2
      if (!method) {
        method = "POST";
      }
    }
    return method;
}

// Get callback response data type.
function getDataType(context) {
  let dataType = context.attr(expressSelectors()['ajax']['data-type']);
  // Don't fallback, if this is not provided then jQuery will default to the Content-Type header.
  // Fallback.
  // if (!dataType) {
  //   dataType = "HTML"
  // }
  if (dataType) {
    // Make sure result is in uppercase.
    dataType = dataType.toUpperCase();
  }
  return dataType;
}

// Get Enctype.
/* 
Wonding why you cannot see the payload when setting mutlipart: 

https://superuser.com/questions/1305812/unable-to-see-request-payload-in-chrome-network-tab

https://stackoverflow.com/questions/55743964/how-to-see-form-data-with-enctype-multipart-form-data-in-chrome-debugger/59871612#59871612
*/

function getEnctype(context) {
  let enctype = context.attr('enctype');
  // Fallback.
  if (!enctype) {
    enctype = "application/x-www-form-urlencoded";
  }
  return enctype;
}


function prepareCallback(context, customConfig = {}) {
  // Check to see if context is a form.
  let isForm = context.is('form');
  // Form id.
  const formId = (isForm ? context.attr('id') : null);
  // Form name ( if it has one ).
  const formName = (isForm ? context.attr('name') : null);
  // The element that triggered this submission ( i.e submit buttons or anchors).
  let submitter = undefined;
  if (customConfig.hasOwnProperty('submitter')) {
    submitter = customConfig['submitter'];
  }
  // Get Url.
  let url = getCallbackLocation(context);
  if (customConfig.hasOwnProperty('url')) {
    url = customConfig['url'];
  }
  // Get Enctype.
  let enctype = getEnctype(context);
  // Is multipart form.
  let isMultipartForm = (enctype == "multipart/form-data");
  // Get Method.
  let method = (customConfig.hasOwnProperty('method') ? customConfig['method'] : getMethod(context));
  // Get data type ( used for the response ).
  let dataType = (customConfig.hasOwnProperty('data-type') ? customConfig['data-type'] : getDataType(context));
  // Form Data.
  let data = null;
  // If this is a multipart form we need to use the FormData interface to be able to pass binary data through the ajax method.
  if (isMultipartForm && isForm) {
    data = new FormData(context[0]);
  } else if (isForm) {
    // As we're not passing binary data then we can use normal serialisation i.e the use of UTF-8 encoded query strings.
    data = serialise(context, true, submitter);
  }
  // Check if there are multiple instance's of forms grouped by name ( i.e. list sorting ).
  if (isForm) {
    const groupedForms = $('form[name="' + formName + '"]:not([id="' + formId + '"])');
    const includeConditionalOptions = (submitter ? (submitter.attr(expressSelectors()['forms']['option-active-force']) != undefined) : false)
    if (groupedForms.length) {
      if (AXISDebug.level() >= 3) {
        AXISDebug.output(1, "AJAX: Form Group Detected " + formName + " grouped form(s) context:", groupedForms);
      }
      // Create a collection of names for inputs / controls within submitted form, this will be used when combining payload with other forms with the same name.
      const inputNames = new Set(
        context.find(':input[name], [' + expressSelectors()['forms']['option-active'] + '], [' + expressSelectors()['forms']['option-active-force'] + '], [' + expressSelectors()['forms']['option-active-conditional']  +']').map(function() {
          return this.name;
        }).get()
      );
      // Loop through forms with the same name that were not submitted.
      groupedForms.each((index, form) => {
        // Grouped form context.
        const groupedForm = $(form);
        // Find missing inputs from original form submission.
        const missingInputs = groupedForm.find(':input[name], [' + expressSelectors()['forms']['option-active'] + '], [' + expressSelectors()['forms']['option-active-force'] + '], [' + expressSelectors()['forms']['option-active-conditional']  +']').filter((index, element) => {
          const input = !inputNames.has(element.name);
          return input;
        });
        // Serialise inputs ( select, input & textarea ) using jQuery's serialize function.
        let values = missingInputs.serialize();
        if (values) {
          data = values + (data ? "&" + data : "");
        }
        // Filter additional controls with data that want get serialised by jQuery's serializer.
        let controls = missingInputs.filter((index, control) => {
          const input = $(control);
          if (input.is(':input[name]')) {
            return;
          }
          // If the submitter does not allow for conditional controls to be submitted then skip.
          if (!includeConditionalOptions) {
            if (input.attr(expressSelectors()['forms']['option-active-conditional']) != undefined) {
              return;
            } 
          }
          if (input.attr(expressSelectors()['forms']['option-active']) != undefined) {
            return input;
          } else if (input.attr(expressSelectors()['forms']['option-active-force']) != undefined) {
            return input;
          }
        });
        // If any controls that are not select, input or textarea are in the mix then serialise those values.
        if (controls.length) {
          data = serialiseOptions(controls, submitter) + (data ? "&" + data : "");
        }
        if (AXISDebug.level() >= 3) {
          AXISDebug.output(1,"Ajax: Data after grouped form serialised", data);
        }
      });
    }
  }
  // Get operation.
  let operation = getOperation(context, isMultipartForm);
  // If operation exists add it to form data.
  if (customConfig.hasOwnProperty('operation')) {
    if (isMultipartForm) {
      data.append('operation', customConfig['operation']);
    } else {
      data = customConfig['operation'] + (data ? "&" + data : "");
    }
  } else if (operation) {
    if (isMultipartForm) {
      data.append("operation", operation);
    } else {
      data = operation + (data ? "&" + data : "");
    }
  }
  // Add AJAX flag for the server.
  let suppressAjaxFlag = (customConfig.hasOwnProperty('suppress-ajax-flag') ? customConfig['suppress-ajax-flag'] : (context.attr(expressSelectors()['ajax']['suppress-ajax-flag']) != undefined));
  if (!suppressAjaxFlag) {
    if (isMultipartForm) {
      data.append('ajax', 1);
    } else {
      // If not suppressed ( likely to be suppress if calling to a third-party api ).
      data = "ajax=1" + (data ? "&" + data : "");
    }
  }
  // Development / static environment variables.
  if (isRunningDevelopment() && !suppressAjaxFlag) {
    if (isMultipartForm) {
      data.append('authenticated', isAuthentication());
    } else {
      data = "authenticated=" + isAuthentication() + (data ? "&" + data : ""); 
    }
  }

  // vMerchant List Context.
  let vmListContextVariable = context.parents('[' + expressSelectors()['ajax']['vm-context-variable'] + ']');
  if (vmListContextVariable.length) {
    vmListContextVariable = vmListContextVariable.attr(expressSelectors()['ajax']['vm-context-variable']);
  }
  let vmListContextValue = context.parents('[' + expressSelectors()['ajax']['vm-context-value'] + ']');
  if (vmListContextValue.length) {
    vmListContextValue = vmListContextValue.attr(expressSelectors()['ajax']['vm-context-value']);
  }

  // Iif content variable & value both exist then add them to the data that gets sent in the callback.
  if (vmListContextVariable.length && vmListContextValue.length) {
    data = vmListContextVariable + "=" + vmListContextValue + (data ? "&" + data : "");
  }

  // Sometimes it is required that we supply a custom key + value pair.
  let getCustomValue = getPairValue(context);
  if (customConfig.hasOwnProperty('custom-name-pair')) {
    if (!isMultipartForm) {
      // if not set to false.
      if (customConfig['custom-name-pair']) {
        data = customConfig['custom-name-pair'] + (data ? "&" + data : "");
      }
    } else {
      AXISDebug.output(2,"AJAX: Custom name value pair is not supported when submitting a multipart form.");
    }
  } else if (getCustomValue) {
    if (isMultipartForm) {
      data.append(getPairKey(context), getPairValue(context));
    } else {
      data = getCustomNameValuePair(context) + (data ? "&" + data : "");
    }
  }

  // If a custom data string has been provided then add it. ( this was developed after custom-name-pair hense the overlap )
  if (customConfig.hasOwnProperty('custom-data-string')) {
    data = customConfig['custom-data-string'] + (data ? "&" + data : "");
  } else if (isMultipartForm && customConfig.hasOwnProperty('custom-data-string')) {
    // This is not support when submitting a multipart form as we will need to develop a function to loop through the string adding it to the FormData object.
    AXISDebug.output(2,"AJAX: Multipart forms don't support custom-data-strings currently.");
  }

  // If include context + multipart form then send console warning due to not supporting.
  if (isMultipartForm && context.attr(expressSelectors()['forms']['include-context']) != undefined) {
    AXISDebug.output(2,"AJAX: There is no support for sending additional form field context when the form has multipart set.");
  }

  // Allow user to navigated away mid-callback.
  let ignoreActiveUnloadPrompt = context.attr(expressSelectors()['ajax']['ignore-active-unload-prompt']);
  // Fallback to custom config.
  if (ignoreActiveUnloadPrompt == undefined) {
    ignoreActiveUnloadPrompt = (customConfig.hasOwnProperty('ignore-active-callbacks') ? customConfig['ignore-active-unload-prompt'] : false);
  }
  // If an empty string then convert to boolean.
  if (ignoreActiveUnloadPrompt == "") {
    ignoreActiveUnloadPrompt = true;
  }
  // Should we allow for multiple requests at once?
  let ignoreActiveCallbacks = (customConfig.hasOwnProperty('ignore-active-callbacks') ? customConfig['ignore-active-callbacks'] : false);

  // Check for xhr fields config just incase we should be expecting a blob.
  let xhrFields = null;
  if (customConfig.hasOwnProperty('xhr-fields')) {
    xhrFields = customConfig['xhr-fields'];
  }
  // Create AJAX instance.
  let instanceId = callbackInstance(url, data, dataType, context, false, method, enctype, isMultipartForm, ignoreActiveUnloadPrompt, submitter, ignoreActiveCallbacks, xhrFields);
  // Return the instance id.
  return instanceId;
}

function doCaptcha(id) {
  return new Promise((resolve, reject) => {
    // Get Context.
    let context = instances[id]['configuration']['context'];
    // Captcha type.
    let captchaType = instances[id]['configuration']['captcha-type'];
    // If no captcha type then you shouldn't be here.
    if (!captchaType) {
      reject("AJAX: No type defined.");
    }
    // Execute recaptcha this will return a widget id, this will potentially present the use with a challenge.
    let widgetId = axisCaptcha.execute(context);
    // Execute captcha.
    switch(captchaType) {
      case "GoogleRecaptchaInvisibleVersion2":
        // Added listeners.
        // Error listener.
        $(document).on('recaptcha-callback-error', function(event, reason, expired) {
          if (reason == undefined || reason == "") {
            reason = "Something went wrong with Google reCaptcha.";
          }            
          if (!expired) {
            // Remove listener as it no longer required.
            $(document).off('recaptcha-callback-response');
            $(document).off('recaptcha-callback-error');
          }
          reject("AJAX: " + reason);
        });
        // Success listener.
        $(document).on('recaptcha-callback-response', function(event, data) {
          if (AXISDebug.level() >= 4) {
            AXISDebug.output(1, "AJAX: reCaptcha executed here is the token & widget id", data);
          }
          // Add token to the configuration.
          instances[id]['configuration']['captcha-token'] = data['token'];
          // Remove listener as it no longer required.
          $(document).off('recaptcha-callback-response');
          $(document).off('recaptcha-callback-error');
          // Reset the recaptcha.
          grecaptcha.reset(data['widget-id']);
          // Resolve to allow for callback along with returning the token.
          resolve(data['token']);
        });
        break;
      case "GoogleRecaptchaCheckboxVersion2" :
        // Make sure context is a form.
        if (!context.is('form')) {
          reject("AJAX: The Google Recaptcha V2 API Checkbox variant can only be used for form submissions.");
        }
        // Get the captcha token.
        let token = axisCaptcha.token(context);
        // If token has not be retrieved then exit.
        if (token == undefined || token == "") {
          rejext("AJAX: Failed to obtain recaptcha token from captcha service cancelling callback.");
        }
        // Add token to the configuration.
        instances[id]['configuration']['captcha-token'] = token;
        // Resolve to allow for callback along with returning the token.
        resolve(token);
        break;
      default:
        reject("AJAX: Could not submit callback as we don't support that captcha type: " + captchaType);
    }
  });
}

// Checks if response is a JSON response.
function isResponseJSON(xhr) {
  // If no XMLHttpRequest object is passed in then exit.
  if (!xhr && typeof(xhr) == "object") {
    AXISDebug.output(2,"AJAX: XMLHttpRequest object was not passed in");
    return false;
  }
  const header = xhr.getResponseHeader("Content-Type");
  const isJson = header.includes("json");
  return isJson;
}


// Gets called to handle JSON updated.
function update(context, data) {
  return new Promise((resolve, reject) => {
    if (data.hasOwnProperty('updates')) {
      // Get instance id.
      let id = context.attr(expressSelectors()['ajax']['instance']);
      // Get updates.
      let updates = data['updates'];
      // Loop through updates
      for (let update of updates) {
        // Where will this update go in the DOM?
        let containerId = update['id'];
        // Find the container we're about to update.
        let updateContainer = $('#' + containerId);
        // what type html or does a specific function need to be called ( i.e maps update )?
        let updateType = update['type'];
        // The content.
        let newContent = update['update'];
        switch(updateType) {
          case "html": 
            if (!updateContainer.length) {
              reject("Could not find container to update in DOM");
            }
            // Clear container before update.
            updateContainer.empty();
            // Loop through elements.
            for (let content of newContent) {
              updateContainer.append(content);
            }

            // Initialise scripts.
            reInitialiseJs(updateContainer);
            // Resolve promise.
            resolve();
            break;
          case "map":
            if (!updateContainer.length) {
              reject("Could not update map due to not being able to find container");
            }
            // Update map with new markers.
            axisInteractiveMaps.updateMap(updateContainer, newContent)
            // Resolve promise.
            resolve();
            break;
          case "basket-update":
            // Pass update data to axis-basket to update header.
            let updateSummary = AXISBasket.updateHeaderSummary(update);
            if (!updateSummary) {
              reject();
            }
            // Resolve promise.
            resolve();
            break;
          case "form-reset":
            // Find form.
            let form = $('form#' + containerId);
            if (!form.length) {
              reject("Reset Form: Could not find form in DOM");
            } else {
              // Make sure what is in context is actually a form.
              if (form.is('form')) {
                if (AXISDebug.level() >= 3) {
                  AXISDebug.output(1,"Reset Form: Resetting form", form);
                }
                form[0].reset();
              } else {
                reject('Reset Form: Can only reset forms');
              }
            }
            resolve();
            break;
          case "focus-element":
            // Element context.
            let element = $('#' + containerId);
            focusElement(element);
            resolve();
            break;
          case "open-modal":
            // Find modal.
            let modal = $('[' + expressSelectors()['modals']['modal-context'] + '=' + containerId + ']');
            // Open modal.
            AXISModals.open(modal);
            break;
          case "analytics-send-event":
            const eventType = containerId;
            const eventData = newContent[0];
            const event = axisGTM.triggerEvent(eventType, eventData);
            resolve();
            break;
          case "session-reauthentication":
            reauthentication(containerId, id);
            break;
          case "scroll-into-view":
            axisScrollIntoView.scroll(updateContainer);
            break;
          case "tag-manager-container-overview":
            // Get ovrview markup.
            const overview = axisManageGoogleTagManager.buildContainerOverview(context, newContent);
            if (overview['success']) {
              updateContainer.html(overview['data']);
              reInitialiseJs(updateContainer);
            } else {
              reject("Failed to build markup for Tag Manager container overview.");
            }
            break;
          case "tag-manager-folders-filter":
            // Get filters markup.
            const folderFilters = axisManageGoogleTagManager.buildFoldersFilter(context, newContent);
            if (folderFilters['success']) {
              updateContainer.html(folderFilters['data']);
              reInitialiseJs(updateContainer);
            } else {
              reject("Failed to build markup for Tag Manager folders filters.");
            }
            break;
          case "tag-manager-configuration-export":
              // Build export markup.
              const containerExport = axisManageGoogleTagManager.buildContainerExport(context, newContent);
              if (containerExport['success']) {
                updateContainer.html(containerExport['data']);
                reInitialiseJs(updateContainer);
              } else {
                reject("Failed to build markup for Tag Manager Export");
              }
              break;
          case "section-open":
              const section = $('#' + containerId);
              if (section.length) {
                sections.open(section);
              } else {
                reject("Could not find section in DOM " + containerId);
              }
            break;
          default:
            reject("Update type not supported " + updateType);
        }
      }

      // BACKWARDS COMPATIBILITY WHICH WAS PUT IN PLACE TO ASSIST DYNAMIC BUILD FOR 838238
      if (data.hasOwnProperty('popupContent')) {
        if (AXISDebug.level() >= 3) {
          AXISDebug.output(1,"Basket: Triggering backwards compatibility for basket update, this doesn't support updating the basket page itself.", data);
        }
        AXISBasket.updateBasketGen1(data);
      }

    } else {

      // BACKWARDS COMPATIBILITY WHICH WAS PUT IN PLACE TO ASSIST DYNAMIC BUILD FOR 838238
      if (data.hasOwnProperty('popupContent')) {
        if (AXISDebug.level() >= 3) {
          AXISDebug.output(1,"Basket: Triggering backwards compatibility for basket update, this doesn't support updating the basket page itself.", data);
        }
        AXISBasket.updateBasketGen1(data);
      }
      
      //reject("Updates array not configured.");
    }
  });
}

function reauthentication(action, id) {
  let pendingInstance = {};
  let contextRestored, instanceIdRestored;
  // If no action the exit.
  if (!action) {
    console.error("Please provide an action", action);
    return false;
  }
  // Do the appropriate action.
  switch(action) {
    case "reauthentication-pending": 
      console.log("pending reauth setting flag(s).");
      // This will eventually get unset once reautenticated and then re-submit the original submission.
      instances[id]['pending-reauthentication'] = true;
      // Setting active flag to prevent any further submission for this element.
      instances[id]['active'] = true;
      console.log(instances[id]);
      break;
    case "reauthentication-complete":
      console.log("authorised, carry out original submision");
      // Find original instance.
      for (let [key, instance] of Object.entries(instances)) {
        if (Object.hasOwn(instance, 'pending-reauthentication')) {
          pendingInstance = instance;
          instanceIdRestored = key;
          break;
        }
      }  
      console.log("instance found", pendingInstance);
      // Get previous instance context.
      contextRestored = pendingInstance['configuration']['context'];
      console.log("cr",contextRestored);
      // What sort of element is this?
      if (contextRestored.length) {
        // For static only.
        contextRestored.find('input[name="reauthentication-required"]').remove();
        if (contextRestored.is('form')) {
          contextRestored.trigger('submit');
        } else {
          console.log("Dropped Session: We don't support that element");
        }
        
        // TODO: this might be too soon.
        // Close modal.
        AXISModals.modalClose();
      }
      break;
    case "reauthentication-cancelled":
      console.log("reauthentication cancelled, returning the user.");
      // Find original instance.
      for (let [key, instance] of Object.entries(instances)) {
        if (Object.hasOwn(instance, 'pending-reauthentication')) {
          pendingInstance = instance;
          instanceIdRestored = key;
          break;
        }
      } 
      // Get previous instance context.
      contextRestored = pendingInstance['configuration']['context'];
      if (contextRestored.length) {
        // For static only.
        contextRestored.find('input[name="reauthentication-required"]').remove();
        contextRestored.append(`<input type="hidden" name="reauthentication-cancelled" value="true" />`);
        // Detect what type of element this and trigger an event relievent to it.
        if (contextRestored.is('form')) {
          contextRestored.trigger('submit');
        } else {
          console.log("Dropped Session: We don't support that element");
        }
        // TODO: this might be too soon, i.e the content in the background maybe either blank or in an unintialised form.
        // Close modal.
        AXISModals.modalClose();
      }
      break;
    default:
      console.log("No action defined or we don't support that action", action);
      return false;
  }
  // TODO: Some sort of clean up regarding flags using instanceIdRestored variable.
}

var AXISAjax = $.AXISAjax = {
  // TODO: post needs to be worked out of the system infavour for callback
  post: (url, data, dataType, context, isList = false) => {
    // Make sure context is a jQuery objext.
    context = jQueryContextCheck(context);
    // Make sure ajax flag is sent.
    data = "ajax=1" + (data ? "&" + data : "");
    // Check if instance already exists or create one.
    let id = callbackInstance(url, data, dataType, context, isList, "POST");

    let form = context;
    // Check if form varable actually contains a form, if not then find it.
    if (!form.is('form')) {
      form = context.parents('form');
    }

    let captchaType = form.attr('data-captcha-type');
    if (captchaType == undefined) {
      instances[id]['configuration']['captcha-required'] = false;
    }
    let request;
    if (captchaType) {
      instances[id]['configuration']['captcha-required'] = true;
      // Execute recaptcha.
      if (captchaType == "GoogleRecaptchaInvisibleVersion2") {
        let widgetId = axisCaptcha.execute(context).catch((error) => {
          console.error(error);
        });
        return new Promise((resolve, reject) => {
          $(document).on('recaptcha-callback-error', function(event, reason, expired) {
            if (reason == undefined || reason == "") {
              reason = "Something went wrong with Google reCaptcha.";
            }            
            if (!expired) {
              // Remove listener as it no longer required.
              $(document).off('recaptcha-callback-response');
              $(document).off('recaptcha-callback-error');
            }
            reject("AJAX: " + reason);
            return false;
          });


          $(document).on('recaptcha-callback-response', function(event, data) {
            if (AXISDebug.level() >= 4) {
              AXISDebug.output(1, "AJAX: reCaptcha executed here is the token & widget id", data);
            }
            // Add token to the configuration.
            instances[id]['configuration']['captcha-token'] = data['token'];
            // Remove listener as it no longer required.
            $(document).off('recaptcha-callback-response');
            $(document).off('recaptcha-callback-error');
            // Reset the recaptcha.
            grecaptcha.reset(data['widget-id']);
            // Do Callback.
            request = doCallback(id).catch((error) => {
              AXISDebug.output(2, error);
            });
            resolve(request);
          });
        });
      } else if (captchaType = "GoogleRecaptchaCheckboxVersion2") {
        if (!context.is('form')) {
          AXISDebug.output(2,"AJAX: The Google Recaptcha V2 API Checkbox variant can only be used for form submissions.");
          instances[id]['configuration']['captcha-required'] = false;
          request = doCallback(id).catch((error) => {
            AXISDebug.output(2, error);
          });
          return request;
        }
        let token = axisCaptcha.token(context);
        // If token has not be retrieved then exit.
        if (token == undefined || token == "") {
          AXISDebug.output(3,"AJAX: Failed to obtain recaptcha token from captcha service cancelling callback.");
          return false;
        }
        // Add token to the configuration.
        instances[id]['configuration']['captcha-token'] = token;
        request = doCallback(id).catch((error) => {
          AXISDebug.output(2, error);
        });

        return request;
      } else {
        AXISDebug.output(3,"AJAX: Could not find captcha type, exiting callback.");
        return false;
      }

    } else {
      return doCallback(id).catch((error) => {
        AXISDebug.output(2, error);
      });
    }
  },
  get: (url, data, dataType, context, isList = false) => {
    // Check if instance already exists or create one.
    let id = callbackInstance(url, data, dataType, context, isList, "GET");
    // Do callback.
    return doCallback(id).catch((error) => {
        AXISDebug.output(2, error);
    });
  },
  // callback: (url, data, dataType, context, isList = false) => {
  callback: (context, customConfig = {}) => {
    // Prepare callback instance.
    let id = prepareCallback(context, customConfig);
    // Check if captcha is required.
    let captchaRequired = instances[id]['configuration']['captcha-required'];
    if (captchaRequired) {
      return doCaptcha(id).then((token) => {
        return doCallback(id).catch((error) => {
          AXISDebug.output(2,error);
        });
      }).catch((error) => {
        AXISDebug.output(2,error);
      });
    } else {
      return doCallback(id);
    }
  },
  getScript: (url, integrity = "", crossOrigin = "") => {
    return getScript(url, integrity, crossOrigin);
  },
  postUrl: (postURL, isAnchor, formInContext, callout = false) => {
    return getCallbackLocation(postURL);
  },
  getOperation: (context) => {
    return getOperation(context);
  },
  getCustomNameValuePair: (context) => {
    return getCustomNameValuePair(context);
  },
  getDataType: (context) => {
    return getDataType(context);
  },
  getMethod: (context) => {
    return getMethod(context);
  },
  serialise: (context, applyExcludes) => {
    return serialise(context, applyExcludes);
  },
  autoSubmit: (context) => {
    return autoSubmit(context);
  },
  cleanup(element, empty = false) {
    //Clear out old events, constructs & elements. In most cases ( modern browsers ) this shouldn't be to much of an issue as the garbage collector should be more than sufficent.
    if (empty) {
      element.empty();
      return true;
    } else if (empty == false) {
      AXISDebug.output(1, "AJAX: Cleaning up DOM removing: ", element)
      element.remove();
      return true;
    }
    return false;
  },
  getCallbackContainer: (context) => {
    return getCallbackContainer(context);
  },
  update: (context, data) => {
    return update(context, data);
  },
  reInitialiseJs: (container) => {
    return reInitialiseJs(container);
  },
  getContentBlockSpinner: (id) => {
    return getContentBlockSpinner(id);
  },
  isCallbackActive: (id) => {
    return isCallbackActive(id);
  },
  isResponseJSON: (xhr) => {
    return isResponseJSON(xhr);
  },
  reauthentication: (id, action) => {
    // Temp stub as this will need its own JS module.
    return reauthentication(id, action);
  }
}

export {
  AXISAjax
}